import React, {FC} from 'react'
import {KTSVG} from '../../../helpers'

const LandingTopBar: FC = () => {
  return (
    <div className='d-flex align-items-stretch flex-shrink-0'>
      <div className='topbar d-flex align-items-stretch flex-shrink-0'>
        {/* Search */}
        {/* begin::User */}

        {/* end::User */}

        {/* Header menu toggle */}
        <div className='d-flex align-items-center ms-lg-5' id='kt_header_user_menu_toggle'>
        <button
    
                className='btn btn-primary fw-bold px-6 py-3  '
                data-bs-toggle='modal'
              >
                Join as a developer{' '}
                <KTSVG
                  path='/media/icons/duotune/arrows/arr024.svg'
                  className='svg-icon-2 svg-icon-success  ms-2'
                />
              </button>
         
        </div>
        <div className='d-flex d-lg-none align-items-center me-n2' title='Show header menu'>
          <button
            className='btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px'
            id='kt_landing_header_menu_mobile_toggle'
          >
            <KTSVG path='/media/icons/duotune/text/txt001.svg' className='svg-icon-1' />
          </button>
        </div>
      </div>
    </div>
  )
}

export {LandingTopBar}
